import { createNavigation } from 'next-intl/navigation'
import { defineRouting } from 'next-intl/routing'

export const locales = ['en', 'ru'] as const
export const localePrefix = 'always'
export const defaultLocale = 'ru'

export const routing = defineRouting({
  locales,
  defaultLocale,
  localePrefix,
})

export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing)
